import APIClient from '@/shared/http/clients/api'

const resourceName = 'holiday'
const APIRegCommon = process.env.APIBaseURLRegulationCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegCommon}/${resourceName}/${id}`, config)

const HolidaysRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete
}

export default HolidaysRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/holiday.js